export const GoToAutocompleteItemIcon = ({
  width = 16,
  height = 16,
  viewBox = '0 0 18 18',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      className="shrink-0"
    >
      <path
        d="M12.75 5.25H5.25V12.75M5.25 5.25L12.75 12.75"
        stroke="#75777D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
